import React, {
  cloneElement,
} from 'react'

const jobBinStatsReport = [
  {
  name: 'Bin',
  type: 'text',
  isSortable: false,
  dataKey: 'bin',
  cellPadding: '0',
},
  {
    name: <div>Unique <br/>part # count</div>,
    type: 'text',
    isSortable: false,
    dataKey: 'unique_partnum_count',
    cellPadding: '0',
  },
  {

    name: <div>Total <br/>part # count</div>,
    type: 'text',
    isSortable: false,
    dataKey: 'total_partnum_count',
    cellPadding: '0',
  },
  {
    name: <div>Manual <br/>part # count</div>,
    type: 'text',
    isSortable: false,
    dataKey: 'manual_partnum_count',
    cellPadding: '0',
  },
  {
    name: <div>Total manual <br/>part # count</div>,
    type: 'text',
    isSortable: false,
    dataKey: 'total_manual_partnum_count',
    cellPadding: '0',
  },
  {

    name: <div>Min <br/>part # </div>,
    type: 'text',
    isSortable: false,
    dataKey: 'min_partnum',
    cellPadding: '0',
  },
  {
    name: <div>Max <br/>part # </div>,
    type: 'text',
    isSortable: false,
    dataKey: 'max_partnum',
    cellPadding: '0',
  }
  ];
const jobBadScansReport = [
  {
    name: 'Entered partnum',
    type: 'text',
    isSortable: false,
    dataKey: 'entered_partnum',
    cellPadding: '0',
  },
  {
    name: 'Bin',
    type: 'text',
    isSortable: false,
    dataKey: 'bin',
    cellPadding: '0',
  },
  {
    name: 'Count',
    type: 'text',
    isSortable: false,
    dataKey: 'partnum_count',
    cellPadding: '0',
  }
];
const jobMissingBinsReport = [
  {
    name: 'Bin',
    type: 'text',
    isSortable: false,
    dataKey: 'bin',
    cellPadding: '0',
  },
  {
    name: 'Distinct partnum count as primary bin',
    type: 'text',
    isSortable: false,
    dataKey: 'distinct_primary_partnum_count',
    cellPadding: '0',
  },
  {
    name: 'Distinct partnum count',
    type: 'text',
    isSortable: false,
    dataKey: 'distinct_partnum_count',
    cellPadding: '0',
  }
];
const jobTasksReport = [
  {
    name: 'Task name',
    type: 'text',
    isSortable: false,
    dataKey: 'task_name',
    cellPadding: '0',
  },
  {
    name: 'Started at',
    type: 'text',
    isSortable: false,
    dataKey: 'started_at',
    cellPadding: '0',
  },
  {
    name: 'Updated at',
    type: 'text',
    isSortable: false,
    dataKey: 'updated_at',
    cellPadding: '0',
  },
  {
    name: 'Status',
    type: 'text',
    isSortable: false,
    dataKey: 'task_status',
    cellPadding: '0',
  }
];
const dealerMonthlyReport = [
  {
    name: 'Month',
    type: 'text',
    isSortable: false,
    dataKey: 'month',
    cellPadding: '0',
  },
  {
    name: 'Job count',
    type: 'text',
    isSortable: false,
    dataKey: 'job_count',
    cellPadding: '0',
  },
];
const userMonthlyReport = [
  {
    name: 'Month',
    type: 'text',
    isSortable: false,
    dataKey: 'month',
    cellPadding: '0',
  },
  {
    name: 'Job count',
    type: 'text',
    isSortable: false,
    dataKey: 'job_count',
    cellPadding: '0',
  },
  {
    name: 'Bin count',
    type: 'text',
    isSortable: false,
    dataKey: 'bin_count',
    cellPadding: '0',
  },
  {
    name: 'Partnum count',
    type: 'text',
    isSortable: false,
    dataKey: 'partnum_count',
    cellPadding: '0',
  },
];
const userOverview = [
  {
    name: 'User name',
    type: 'text',
    isSortable: false,
    dataKey: 'user_name',
    cellPadding: '0',
  },
  {
    name: 'Job count',
    type: 'text',
    isSortable: false,
    dataKey: 'job_count',
    cellPadding: '0',
  },

];

const brandOverview = [
  {
    name: 'Brand',
    type: 'text',
    isSortable: false,
    dataKey: 'brand',
    cellPadding: '0',
  },
  {
    name: 'Dealer count',
    type: 'text',
    isSortable: false,
    dataKey: 'dealer_count',
    cellPadding: '0',
  },

  {
    name: 'Job count',
    type: 'text',
    isSortable: false,
    dataKey: 'job_count',
    cellPadding: '0',
  },

];
const tableColumns = {
  job_bin_stats: jobBinStatsReport,
  job_bad_scans: jobBadScansReport,
  job_missing_bins: jobMissingBinsReport,
  job_tasks: jobTasksReport,
  dealer_monthly: dealerMonthlyReport,
  user_monthly: userMonthlyReport,
  user_overview: userOverview,
  brand_overview: brandOverview
}

export default tableColumns;
